import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const principles = [
  {
    icon: 'ri-lock-line',
    title: 'Cost Effective',
    description: 'Bütçeyi doğru yere odaklarız.',
  },
  {
    icon: 'ri-flashlight-line',
    title: 'Speed',
    description: 'Hızlı karar, hızlı üretim, hızlı sonuç.',
  },
  {
    icon: 'ri-palette-line',
    title: 'Craft',
    description: 'Her detay özenle tasarlanır ve üretilir.',
  },
  {
    icon: 'ri-bar-chart-line',
    title: 'Data',
    description: 'Kararlar sezgiye değil, veriye dayanır.',
  },
  {
    icon: 'ri-plant-line',
    title: 'Long Term',
    description: 'Kısa vadeli taktik değil, sürdürülebilir büyüme.',
  },
];

export default function Principles() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section ref={ref} className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="font-serif text-4xl text-charcoal mb-16"
        >
          Nasıl Çalışıyoruz
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6">
          {principles.map((principle, index) => (
            <motion.div
              key={principle.title}
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-white border border-gray-200 rounded-xl p-6 hover:shadow-lg transition-shadow"
            >
              <div className="w-10 h-10 flex items-center justify-center mb-4">
                <i className={`${principle.icon} text-3xl text-charcoal`}></i>
              </div>
              <h3 className="font-sans font-semibold text-lg text-charcoal mb-2">
                {principle.title}
              </h3>
              <p className="font-sans text-sm text-gray-medium leading-relaxed">
                {principle.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
